import { formatDate, formatTime, formatNumber } from '@/utils/format';

class InstagramLiveMetadata {
  id: string;

  mediaId: string;

  billingCreditId: string;

  accountId: string;

  accountUsername: string;

  commentsCount: number;

  realCommentsCount: number;

  realUsersCount: number;

  likeCount: number;

  mediaType: string;

  permalink: string;

  shortcode: string;

  createdAt: Date;

  updatedAt: Date;

  pluginId: string;

  pluginType: string;

  profilePictureBase64: string;

  aiProductsStatus: string;

  aiProductsCartsStatus: string;

  fullInstagramSyncAt: Date | null;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor({
    id,
    mediaId,
    billingCreditId,
    accountId,
    accountUsername,
    commentsCount,
    realCommentsCount,
    realUsersCount,
    likeCount,
    mediaType,
    permalink,
    shortcode,
    createdAt,
    updatedAt,
    pluginId,
    pluginType,
    profilePictureBase64,
    aiProductsStatus,
    aiProductsCartsStatus,
    fullInstagramSyncAt,
  }: {
    id: string;
    mediaId: string;
    billingCreditId: string;
    accountId: string;
    accountUsername: string;
    commentsCount: number;
    realCommentsCount: number;
    realUsersCount: number;
    likeCount: number;
    mediaType: string;
    permalink: string;
    shortcode: string;
    createdAt: Date;
    updatedAt: Date;
    pluginId: string;
    pluginType: string;
    profilePictureBase64: string;
    aiProductsStatus: string;
    aiProductsCartsStatus: string;
    fullInstagramSyncAt: Date | null;
  }) {
    this.id = id;
    this.mediaId = mediaId;
    this.billingCreditId = billingCreditId;
    this.accountId = accountId;
    this.accountUsername = accountUsername;
    this.commentsCount = commentsCount;
    this.realCommentsCount = realCommentsCount;
    this.realUsersCount = realUsersCount || 0;
    this.likeCount = likeCount;
    this.mediaType = mediaType;
    this.permalink = permalink;
    this.shortcode = shortcode;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.pluginId = pluginId;
    this.pluginType = pluginType;
    this.profilePictureBase64 = profilePictureBase64;
    this.aiProductsStatus = aiProductsStatus;
    this.aiProductsCartsStatus = aiProductsCartsStatus;
    this.fullInstagramSyncAt = fullInstagramSyncAt;
  }

  missingPayment(): boolean {
    return !this.billingCreditId;
  }

  getShortId(): string {
    return this.id.substring(0, 16);
  }

  getLiveFirstMessageDate(): string {
    return formatDate(this.createdAt, {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    });
  }

  getLiveFirstMessageTime(): string {
    return formatTime(this.createdAt, {
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  formattedCommentsCount(): string {
    return formatNumber(this.realCommentsCount);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static fromApiResponse(columns: string[], rows: any[][]): InstagramLiveMetadata[] {
    if (rows.length === 0) {
      return [];
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return rows.map((row: any[]) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const v: any = {};
      columns.forEach((column, index) => {
        const camelCaseKey = column.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
        if (row[index] && (camelCaseKey === 'Id')) {
          v.id = row[index].toString();
        } else if (row[index] && (camelCaseKey === 'updatedAt' || camelCaseKey === 'createdAt' || camelCaseKey === 'fullInstagramSyncAt')) {
          v[camelCaseKey] = new Date(row[index]);
        } else {
          v[camelCaseKey] = row[index];
        }
      });
      return new InstagramLiveMetadata(v);
    });
  }
}

export default InstagramLiveMetadata;
